"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNDER_DEVELOPMENT_METRICS = exports.TZM_METRICS = exports.NRT_METRICS = exports.SITE_METRICS = exports.PAGE_METRICS = exports.SDK_ZONE_METRICS = exports.WEB_ZONE_METRICS = exports.ZONE_METRICS = exports.ALL_METRICS_V2 = exports.ALL_METRICS = void 0;
const global_constants_1 = require("@contentsquare/global-constants");
const global_1 = require("./global");
const utils_1 = require("./utils");
// 17
const WEB_ZONE_METRICS = [
    {
        id: global_1.ZoneWebMetricId.AttractivenessRate,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: true,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: true,
        name: 'METRIC.ZONING.ATTRACTIVENESS_RATE',
        definition: 'COMMON.METRICS_DEFINITION.ATTRACTIVENESS_RATE',
        category: global_1.ZoneMetricCategory.Interaction,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.ZoneWebMetricId.AverageRevenueAfterClick,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: true,
        name: 'METRIC.ZONING.REVENUE_PER_CLICK',
        definition: 'METRIC.DEFINITION.ZONING.SITE.REVENUE_PER_CLICK',
        category: global_1.ZoneMetricCategory.ROI,
        formatType: utils_1.NumberFormatTypes.Currency,
        format: (value, options) => utils_1.Formatter.currency(value, options),
    },
    {
        id: global_1.ZoneWebMetricId.AvgConversionAfterClick,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
        name: 'METRIC.ZONING.CONVERSION_AFTER_CLICK',
        definition: 'METRIC.DEFINITION.ZONING.SITE.CONVERSION_AFTER_CLICK',
        category: global_1.ZoneMetricCategory.Performance,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.ZoneWebMetricId.AvgConversionAfterHover,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop],
        isEcommerce: false,
        name: 'METRIC.ZONING.CONVERSION_AFTER_HOVER',
        definition: 'METRIC.DEFINITION.ZONING.SITE.CONVERSION_AFTER_HOVER',
        category: global_1.ZoneMetricCategory.Performance,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.ZoneWebMetricId.AvgTransactionAfterHover,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop],
        isEcommerce: true,
        name: 'METRIC.ZONING.TRANSACTION_AFTER_HOVER',
        definition: 'METRIC.DEFINITION.ZONING.SITE.TRANSACTION_AFTER_HOVER',
        category: global_1.ZoneMetricCategory.ROI,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.ZoneWebMetricId.AvgExposureTime,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: true,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: true,
        name: 'METRIC.ZONING.EXPOSURE_TIME',
        definition: 'COMMON.METRICS_DEFINITION.EXPOSURE_TIME',
        category: global_1.ZoneMetricCategory.Heatmap,
        formatType: utils_1.NumberFormatTypes.Seconds,
        format: (value, options) => utils_1.Formatter.seconds(value, options),
    },
    {
        id: global_1.ZoneWebMetricId.AvgHoverTime,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop],
        isEcommerce: false,
        name: 'METRIC.ZONING.FLOAT_TIME',
        definition: 'METRIC.DEFINITION.ZONING.SITE.FLOAT_TIME',
        category: global_1.ZoneMetricCategory.Interaction,
        formatType: utils_1.NumberFormatTypes.Seconds,
        format: (value, options) => utils_1.Formatter.seconds(value, options),
    },
    {
        id: global_1.ZoneWebMetricId.AvgTransactionAfterClick,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: true,
        name: 'METRIC.ZONING.TRANSACTION_AFTER_CLICK',
        definition: 'METRIC.DEFINITION.ZONING.SITE.TRANSACTION_AFTER_CLICK',
        category: global_1.ZoneMetricCategory.ROI,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.ZoneWebMetricId.ClickRate,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
        name: 'METRIC.ZONING.CLICK_RATE',
        definition: 'METRIC.DEFINITION.ZONING.SITE.CLICK_RATE',
        category: global_1.ZoneMetricCategory.Attractiveness,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.ZoneWebMetricId.ClickRateSession,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
        name: 'METRIC.ZONING.CLICK_RATE_SESSION',
        definition: 'METRIC.DEFINITION.ZONING.SITE.CLICK_RATE_SESSION',
        category: global_1.ZoneMetricCategory.Attractiveness,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.ZoneWebMetricId.ClickRepetition,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
        name: 'METRIC.ZONING.CLICK_RECURRENCE',
        definition: 'METRIC.DEFINITION.ZONING.SITE.CLICK_RECURRENCE',
        category: global_1.ZoneMetricCategory.Interaction,
        formatType: utils_1.NumberFormatTypes.Number,
        format: (value, options) => utils_1.Formatter.number(value, options),
    },
    {
        id: global_1.ZoneWebMetricId.DragRateWeb,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: true,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
        name: 'METRIC.ZONING.DRAG_RATE_WEB',
        definition: 'METRIC.DEFINITION.ZONING.SITE.DRAG_RATE_WEB',
        category: global_1.ZoneMetricCategory.Interaction,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.ZoneWebMetricId.EngagementRateLive,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop],
        isEcommerce: false,
        name: 'METRIC.ZONING.ENGAGEMENT_RATE',
        definition: 'METRIC.DEFINITION.ZONING.SITE.ENGAGEMENT_RATE',
        category: global_1.ZoneMetricCategory.Interaction,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.ZoneWebMetricId.ExposureRate,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: true,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
        name: 'METRIC.ZONING.EXPOSURE_RATE',
        definition: 'COMMON.METRICS_DEFINITION.EXPOSURE_RATE',
        category: global_1.ZoneMetricCategory.Heatmap,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.ZoneWebMetricId.FlickRateWeb,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: true,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
        name: 'METRIC.ZONING.FLICK_RATE_WEB',
        definition: 'METRIC.DEFINITION.ZONING.SITE.FLICK_RATE_WEB',
        category: global_1.ZoneMetricCategory.Interaction,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.ZoneWebMetricId.Hesitation,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: true,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop],
        isEcommerce: false,
        name: 'METRIC.ZONING.HESITATION',
        definition: 'METRIC.DEFINITION.ZONING.SITE.HESITATION',
        category: global_1.ZoneMetricCategory.Interaction,
        formatType: utils_1.NumberFormatTypes.Seconds,
        format: (value, options) => utils_1.Formatter.seconds(value, options),
    },
    {
        id: global_1.ZoneWebMetricId.HoverRate,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: true,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop],
        isEcommerce: false,
        name: 'METRIC.ZONING.HOVER_RATE',
        definition: 'METRIC.DEFINITION.ZONING.SITE.HOVER_RATE',
        category: global_1.ZoneMetricCategory.Interaction,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.ZoneWebMetricId.TimeBeforeFirstClick,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: true,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
        name: 'METRIC.ZONING.TIME_BEFORE_FIRST_CLICK',
        definition: 'METRIC.DEFINITION.ZONING.SITE.TIME_BEFORE_FIRST_CLICK',
        category: global_1.ZoneMetricCategory.Attractiveness,
        formatType: utils_1.NumberFormatTypes.Seconds,
        format: (value, options) => utils_1.Formatter.seconds(value, options),
    },
    {
        id: global_1.ZoneWebMetricId.TotalClicks,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: true,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
        name: 'METRIC.ZONING.TOTAL_CLICKS',
        definition: 'METRIC.DEFINITION.ZONING.SITE.TOTAL_CLICKS',
        category: global_1.ZoneMetricCategory.Attractiveness,
        formatType: utils_1.NumberFormatTypes.Integer,
        format: (value, locales) => utils_1.Formatter.integer(value, locales),
    },
    {
        id: global_1.ZoneWebMetricId.TotalRevenueAfterClick,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: true,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: true,
        name: 'METRIC.ZONING.REVENUE',
        definition: 'METRIC.DEFINITION.ZONING.SITE.REVENUE',
        category: global_1.ZoneMetricCategory.ROI,
        formatType: utils_1.NumberFormatTypes.Currency,
        format: (value, options) => utils_1.Formatter.currency(value, options),
    },
];
exports.WEB_ZONE_METRICS = WEB_ZONE_METRICS;
// 8
const SDK_ZONE_METRICS = [
    {
        id: global_1.ZoneSDKMetricId.AverageRevenueAfterTap,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: true,
        name: 'METRIC.ZONING.REVENUE_PER_TAP',
        definition: 'METRIC.DEFINITION.ZONING.SDK.REVENUE_PER_TAP',
        category: global_1.ZoneMetricCategory.ROI,
        formatType: utils_1.NumberFormatTypes.Currency,
        format: (value, options) => utils_1.Formatter.currency(value, options),
    },
    {
        id: global_1.ZoneSDKMetricId.AvgConversionAfterTap,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.ZONING.CONVERSION_AFTER_TAP',
        definition: 'METRIC.DEFINITION.ZONING.SDK.CONVERSION_AFTER_TAP',
        category: global_1.ZoneMetricCategory.Performance,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.ZoneSDKMetricId.AvgTransactionAfterTap,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: true,
        name: 'METRIC.ZONING.TRANSACTION_AFTER_TAP',
        category: global_1.ZoneMetricCategory.ROI,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    // 8 other metrics
    // {
    //   id: ZoneSDKMetricId.DragFlickRate,
    //   interface: Interface.Zone,
    //   isExposureMetric: false,
    //   isFingerMetric: false,
    //   devices: [Device.MobileSdk, Device.TabletSdk],
    //   isSDK: true,
    //   isEcommerce: true,
    //   name: 'METRIC.ZONING.TRANSACTION_AFTER_TAP',
    //   format: (rate) => '',
    // },
    {
        id: global_1.ZoneSDKMetricId.TapCount,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: true,
        name: 'METRIC.ZONING.TAP_COUNT',
        category: global_1.ZoneMetricCategory.Attractiveness,
        formatType: utils_1.NumberFormatTypes.Integer,
        format: (value, options) => utils_1.Formatter.integer(value, options),
    },
    {
        id: global_1.ZoneSDKMetricId.TapRate,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.ZONING.TAP_RATE',
        definition: 'METRIC.DEFINITION.ZONING.SDK.TAP_RATE',
        category: global_1.ZoneMetricCategory.Attractiveness,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.ZoneSDKMetricId.TapRateSession,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.ZONING.TAP_RATE_SESSION',
        definition: 'METRIC.DEFINITION.ZONING.SDK.TAP_RATE_SESSION',
        category: global_1.ZoneMetricCategory.Attractiveness,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.ZoneSDKMetricId.TapRecurrence,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.ZONING.TAP_RECURRENCE',
        definition: 'METRIC.DEFINITION.ZONING.SDK.TAP_RECURRENCE',
        category: global_1.ZoneMetricCategory.Interaction,
        formatType: utils_1.NumberFormatTypes.Number,
        format: (value, options) => utils_1.Formatter.number(value, options),
    },
    {
        id: global_1.ZoneSDKMetricId.TimeBeforeFirstTap,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.ZONING.TIME_BEFORE_FIRST_TAP',
        definition: 'METRIC.DEFINITION.ZONING.SDK.TIME_BEFORE_FIRST_TAP',
        category: global_1.ZoneMetricCategory.Attractiveness,
        formatType: utils_1.NumberFormatTypes.Seconds,
        format: (value, options) => utils_1.Formatter.seconds(value, options),
    },
    {
        id: global_1.ZoneSDKMetricId.TotalRevenueWithTap,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: true,
        name: 'METRIC.ZONING.REVENUE',
        definition: 'METRIC.DEFINITION.ZONING.SDK.REVENUE',
        category: global_1.ZoneMetricCategory.ROI,
        formatType: utils_1.NumberFormatTypes.Currency,
        format: (value, options) => utils_1.Formatter.currency(value, options),
    },
];
exports.SDK_ZONE_METRICS = SDK_ZONE_METRICS;
const ZONE_METRICS = [...WEB_ZONE_METRICS, ...SDK_ZONE_METRICS];
exports.ZONE_METRICS = ZONE_METRICS;
const PAGE_METRICS = [
    {
        id: global_1.PageMetricId.ActivityRate,
        interface: global_constants_1.Interface.Page,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
        name: 'METRIC.ACTIVITY_RATE',
        definition: 'METRIC.DEFINITION.PAGE.ACTIVITY_RATE',
        category: global_1.MetricCategory.Attractiveness,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.PageMetricId.BounceRate,
        interface: global_constants_1.Interface.Page,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.BOUNCE_RATE',
        definition: 'METRIC.DEFINITION.PAGE.BOUNCE_RATE',
        category: global_1.MetricCategory.Performance,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        // To be used for transactions and goals ??? what's that
        id: global_1.PageMetricId.ConversionRate,
        interface: global_constants_1.Interface.Page,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.CONVERSION_RATE',
        definition: 'METRIC.DEFINITION.PAGE.CONVERSION_RATE',
        category: global_1.MetricCategory.Performance,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.PageMetricId.ElapsedTime,
        interface: global_constants_1.Interface.Page,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.ELAPSED_TIME',
        definition: 'METRIC.DEFINITION.PAGE.ELAPSED_TIME',
        category: global_1.MetricCategory.Attractiveness,
        formatType: utils_1.NumberFormatTypes.Seconds,
        format: (value, options) => utils_1.Formatter.seconds(value, options),
    },
    {
        id: global_1.PageMetricId.ExitRate,
        interface: global_constants_1.Interface.Page,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.EXIT_RATE',
        definition: 'METRIC.DEFINITION.PAGE.EXIT_RATE',
        category: global_1.MetricCategory.Performance,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    // {
    //   id: PageMetricId.FoldHeight,
    //   interface: Interface.Page,
    //   devices: [Device.All, Device.Desktop, Device.Mobile, Device.Tablet, Device.MobileSdk, Device.TabletSdk],
    //   isEcommerce: false,
    //   name: '',
    //   format: (number) => '',
    // },
    // {
    //   id: PageMetricId.InteractionTimeAverage,
    //   interface: Interface.Page,
    //   devices: [Device.All, Device.Desktop, Device.Mobile, Device.Tablet, Device.MobileSdk, Device.TabletSdk],
    //   isEcommerce: false,
    //   name: 'METRIC.EXIT_RATE',
    //   format: (rate) => '',
    // },
    {
        id: global_1.PageMetricId.LandingRate,
        interface: global_constants_1.Interface.Page,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.LANDING_RATE',
        category: global_1.MetricCategory.Performance,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.PageMetricId.LoadingTime,
        interface: global_constants_1.Interface.Page,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
        name: 'METRIC.LOADING_TIME',
        definition: 'METRIC.DEFINITION.PAGE.LOADING_TIME',
        category: global_1.MetricCategory.Speed,
        formatType: utils_1.NumberFormatTypes.Seconds,
        format: (value, options) => utils_1.Formatter.seconds(value, options),
    },
    {
        id: global_1.PageMetricId.PageHeight,
        interface: global_constants_1.Interface.Page,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
        name: 'METRIC.PAGE_HEIGHT',
        formatType: utils_1.NumberFormatTypes.Integer,
        format: (value, options) => utils_1.Formatter.integer(value, options),
    },
    {
        id: global_1.PageMetricId.ScrollRate,
        interface: global_constants_1.Interface.Page,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
        name: 'METRIC.SCROLL_RATE',
        definition: 'METRIC.DEFINITION.PAGE.SCROLL_RATE',
        category: global_1.MetricCategory.Interaction,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.PageMetricId.UniqueUsers,
        interface: global_constants_1.Interface.Page,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.UNIQUE_VISITS',
        formatType: utils_1.NumberFormatTypes.Integer,
        format: (values, options) => utils_1.Formatter.integer(values, options),
    },
    {
        id: global_1.PageMetricId.ViewAverage,
        interface: global_constants_1.Interface.Page,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.VIEWS_PER_VISIT',
        definition: 'METRIC.DEFINITION.PAGE.VIEWS_PER_VISIT',
        category: global_1.MetricCategory.Performance,
        formatType: utils_1.NumberFormatTypes.Number,
        format: (value, options) => utils_1.Formatter.number(value, options),
    },
    {
        id: global_1.PageMetricId.ViewCount,
        interface: global_constants_1.Interface.Page,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.VIEWS',
        definition: 'METRIC.DEFINITION.PAGE.VIEWS',
        category: global_1.MetricCategory.Performance,
        formatType: utils_1.NumberFormatTypes.Integer,
        format: (value, options) => utils_1.Formatter.integer(value, options),
    },
    {
        id: global_1.PageMetricId.VisitCount,
        interface: global_constants_1.Interface.Page,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.VISITS',
        definition: 'METRIC.DEFINITION.PAGE.VISITS',
        category: global_1.MetricCategory.Performance,
        formatType: utils_1.NumberFormatTypes.Integer,
        format: (value, options) => utils_1.Formatter.integer(value, options),
    },
    {
        id: global_1.PageMetricId.VisitRate,
        interface: global_constants_1.Interface.Page,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.VISIT_RATE',
        definition: 'METRIC.DEFINITION.PAGE.VISIT_RATE',
        category: global_1.MetricCategory.Performance,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
];
exports.PAGE_METRICS = PAGE_METRICS;
const SITE_METRICS = [
    {
        id: global_1.SiteMetricId.BounceRate,
        interface: global_constants_1.Interface.Site,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.BOUNCE_RATE',
        definition: 'METRIC.DEFINITION.SITE.BOUNCE_RATE',
        category: global_1.MetricCategory.Performance,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.SiteMetricId.CartAverage,
        interface: global_constants_1.Interface.Site,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: true,
        name: 'METRIC.CART_AVERAGE',
        definition: 'METRIC.DEFINITION.SITE.CART_AVERAGE',
        category: global_1.MetricCategory.ROI,
        formatType: utils_1.NumberFormatTypes.Currency,
        format: (value, options) => utils_1.Formatter.currency(value, options),
    },
    {
        id: global_1.SiteMetricId.CartMedian,
        interface: global_constants_1.Interface.Site,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: true,
        name: 'METRIC.CART_AVERAGE',
        category: global_1.MetricCategory.ROI,
        formatType: utils_1.NumberFormatTypes.Currency,
        format: (value, options) => utils_1.Formatter.currency(value, options),
    },
    {
        id: global_1.SiteMetricId.ConversionCount,
        interface: global_constants_1.Interface.Site,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.CONVERSION_COUNT',
        definition: 'METRIC.DEFINITION.SITE.CONVERSION_COUNT',
        category: global_1.MetricCategory.Performance,
        formatType: utils_1.NumberFormatTypes.Integer,
        format: (value, options) => utils_1.Formatter.integer(value, options),
    },
    {
        id: global_1.SiteMetricId.ConversionRate,
        interface: global_constants_1.Interface.Site,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.CONVERSION_RATE',
        definition: 'METRIC.DEFINITION.SITE.CONVERSION_RATE',
        category: global_1.MetricCategory.Performance,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.SiteMetricId.NewVisits,
        interface: global_constants_1.Interface.Site,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.NEW_VISITS',
        formatType: utils_1.NumberFormatTypes.Integer,
        format: (value, options) => utils_1.Formatter.integer(value, options),
    },
    {
        id: global_1.SiteMetricId.RevenueSum,
        interface: global_constants_1.Interface.Site,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: true,
        name: 'METRIC.REVENUE',
        definition: 'METRIC.DEFINITION.SITE.REVENUE',
        category: global_1.MetricCategory.ROI,
        formatType: utils_1.NumberFormatTypes.Currency,
        format: (value, options) => utils_1.Formatter.currency(value, options),
    },
    {
        id: global_1.SiteMetricId.SessionTimeAverage,
        interface: global_constants_1.Interface.Site,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.SESSION_TIME_AVERAGE',
        definition: 'METRIC.DEFINITION.SITE.SESSION_TIME_AVERAGE',
        category: global_1.MetricCategory.Attractiveness,
        formatType: utils_1.NumberFormatTypes.Duration,
        format: (value) => utils_1.Formatter.duration(value),
    },
    {
        id: global_1.SiteMetricId.ViewAverage,
        interface: global_constants_1.Interface.Site,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.VIEWS_PER_VISIT',
        definition: 'METRIC.DEFINITION.SITE.VIEWS_PER_VISIT',
        category: global_1.MetricCategory.Performance,
        formatType: utils_1.NumberFormatTypes.Number,
        format: (value, options) => utils_1.Formatter.number(value, options),
    },
    {
        id: global_1.SiteMetricId.Views,
        interface: global_constants_1.Interface.Site,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.VIEWS',
        definition: 'METRIC.DEFINITION.SITE.VIEWS',
        category: global_1.MetricCategory.Performance,
        formatType: utils_1.NumberFormatTypes.Number,
        format: (value, options) => utils_1.Formatter.number(value, options),
    },
    {
        id: global_1.SiteMetricId.VisitCount,
        interface: global_constants_1.Interface.Site,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.VISITS',
        definition: 'METRIC.DEFINITION.SITE.VISITS',
        category: global_1.MetricCategory.Performance,
        formatType: utils_1.NumberFormatTypes.Integer,
        format: (value, options) => utils_1.Formatter.integer(value, options),
    },
    {
        id: global_1.SiteMetricId.VisitRate,
        interface: global_constants_1.Interface.Site,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'METRIC.VISIT_RATE',
        definition: 'METRIC.DEFINITION.SITE.VISIT_RATE',
        category: global_1.MetricCategory.Performance,
        formatType: utils_1.NumberFormatTypes.Integer,
        format: (value, options) => utils_1.Formatter.integer(value, options),
    },
];
exports.SITE_METRICS = SITE_METRICS;
const NRT_METRICS = [
    {
        id: global_1.NRTMetricId.ErrorsCount,
        interface: [global_constants_1.Interface.Site, global_constants_1.Interface.Page],
        name: 'WORKSPACE.REALTIME.METRICS.ERRORS_COUNT',
        category: global_1.MetricCategory.NRT,
        formatType: utils_1.NumberFormatTypes.Integer,
        format: (value, options) => utils_1.Formatter.integer(value, options),
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
    },
    {
        id: global_1.NRTMetricId.UsersWithErrorsCount,
        interface: [global_constants_1.Interface.Site, global_constants_1.Interface.Page],
        name: 'WORKSPACE.REALTIME.METRICS.USERS_WITH_ERRORS_COUNT',
        definition: 'METRIC.DEFINITION.NRT.USERS_WITH_ERRORS_COUNT',
        category: global_1.MetricCategory.NRT,
        formatType: utils_1.NumberFormatTypes.Integer,
        format: (value, options) => utils_1.Formatter.integer(value, options),
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
    },
    {
        id: global_1.NRTMetricId.UsersWithErrorsRate,
        interface: [global_constants_1.Interface.Site, global_constants_1.Interface.Page],
        name: 'WORKSPACE.REALTIME.METRICS.USERS_WITH_ERRORS_RATE',
        definition: 'METRIC.DEFINITION.NRT.USERS_WITH_ERRORS_RATE',
        category: global_1.MetricCategory.NRT,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
    },
    {
        id: global_1.NRTMetricId.ViewsWithErrorsCount,
        interface: [global_constants_1.Interface.Site, global_constants_1.Interface.Page],
        name: 'WORKSPACE.REALTIME.METRICS.VIEWS_WITH_ERRORS_COUNT',
        definition: 'METRIC.DEFINITION.NRT.VIEWS_WITH_ERRORS_COUNT',
        category: global_1.MetricCategory.NRT,
        formatType: utils_1.NumberFormatTypes.Integer,
        format: (value, options) => utils_1.Formatter.integer(value, options),
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
    },
    {
        id: global_1.NRTMetricId.ViewsWithErrorsRate,
        interface: [global_constants_1.Interface.Site, global_constants_1.Interface.Page],
        name: 'WORKSPACE.REALTIME.METRICS.VIEWS_WITH_ERRORS_RATE',
        definition: 'METRIC.DEFINITION.NRT.VIEWS_WITH_ERRORS_RATE',
        category: global_1.MetricCategory.NRT,
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
    },
];
exports.NRT_METRICS = NRT_METRICS;
const TZM_METRICS = [
    {
        id: global_1.TzmMetricId.AddToCartRate,
        interface: global_constants_1.Interface.Site,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: true,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.TzmMetricId.Exhaustiveness,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.TzmMetricId.AttractivityRate,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: true,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.TzmMetricId.AvgConversionAfterDrag,
        interface: global_constants_1.Interface.Site,
        isExposureMetric: false,
        isFingerMetric: true,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.TzmMetricId.AvgConversionAfterFlick,
        interface: global_constants_1.Interface.Site,
        isExposureMetric: false,
        isFingerMetric: true,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.TzmMetricId.AvgConversionAfterSwipe,
        interface: global_constants_1.Interface.Site,
        isExposureMetric: true,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.TzmMetricId.CoveredViewsCount,
        interface: global_constants_1.Interface.Page,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Number,
        format: (value, options) => utils_1.Formatter.currency(value, options),
    },
    {
        id: global_1.TzmMetricId.DragFlickRate,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: true,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.TzmMetricId.DragFlickRecurrence,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: true,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: true,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.TzmMetricId.DragRate,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: true,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: true,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.TzmMetricId.DragRecurrence,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: true,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: true,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.TzmMetricId.FlickRate,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: true,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.TzmMetricId.FlickRecurrence,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: true,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
        isEcommerce: false,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.TzmMetricId.FoldHeight,
        interface: global_constants_1.Interface.Page,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Pixels,
        format: (value, options) => utils_1.Formatter.pixels(value, options),
    },
    {
        id: global_1.TzmMetricId.InteractionTime,
        interface: global_constants_1.Interface.Site,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Seconds,
        format: (value, options) => utils_1.Formatter.milliseconds(value, options),
    },
    {
        id: global_1.TzmMetricId.SrViewCount,
        interface: global_constants_1.Interface.Site,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Number,
        format: (value, options) => utils_1.Formatter.number(value, options),
    },
    {
        id: global_1.TzmMetricId.SrVisitCount,
        interface: global_constants_1.Interface.Site,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Number,
        format: (value, options) => utils_1.Formatter.number(value, options),
    },
    {
        id: global_1.TzmMetricId.TotalHovers,
        interface: global_constants_1.Interface.Site,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Number,
        format: (value, options) => utils_1.Formatter.number(value, options),
    },
    {
        id: global_1.TzmMetricId.TransactionCount,
        interface: global_constants_1.Interface.Site,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: true,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Number,
        format: (value, options) => utils_1.Formatter.number(value, options),
    },
    {
        id: global_1.TzmMetricId.TransactionRate,
        interface: global_constants_1.Interface.Site,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: true,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Rate,
        format: (value, options) => utils_1.Formatter.rate(value, options),
    },
    {
        id: global_1.TzmMetricId.UncoveredViewsCount,
        interface: global_constants_1.Interface.Page,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Number,
        format: (value, options) => utils_1.Formatter.number(value, options),
    },
    {
        id: global_1.TzmMetricId.UnitSoldCount,
        interface: global_constants_1.Interface.Site,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: true,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Number,
        format: (value, options) => utils_1.Formatter.number(value, options),
    },
    {
        id: global_1.TzmMetricId.ViewsWithClick,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Number,
        format: (value, options) => utils_1.Formatter.number(value, options),
    },
    {
        id: global_1.TzmMetricId.ViewsWithHover,
        interface: global_constants_1.Interface.Zone,
        isExposureMetric: false,
        isFingerMetric: false,
        devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet, global_constants_1.Device.MobileSdk, global_constants_1.Device.TabletSdk],
        isEcommerce: false,
        name: 'TBD',
        formatType: utils_1.NumberFormatTypes.Number,
        format: (value, options) => utils_1.Formatter.number(value, options),
    },
];
exports.TZM_METRICS = TZM_METRICS;
/**
 * Use this array to store the metrics that are under development or rollout phase
 * You will need to manually add them in the relevant arrays in function of the feature flag value
 * Once the feature flag is cleaned, move those metrics in the relevant *_METRICS array above
 */
const UNDER_DEVELOPMENT_METRICS = [];
exports.UNDER_DEVELOPMENT_METRICS = UNDER_DEVELOPMENT_METRICS;
const ALL_METRICS = [...ZONE_METRICS, ...PAGE_METRICS, ...SITE_METRICS];
exports.ALL_METRICS = ALL_METRICS;
const ALL_METRICS_V2 = [...ZONE_METRICS, ...PAGE_METRICS, ...SITE_METRICS, ...TZM_METRICS];
exports.ALL_METRICS_V2 = ALL_METRICS_V2;
//# sourceMappingURL=metrics.js.map